<template>
  <div class="layout">
    <app-header />
    <slideshow v-if="showingSlideshow" />
    <Gallery />
  </div>
</template>

<script>
import AppHeader from '@/components/app/AppHeader';
import Gallery from '@/components/teacher-gallery/Gallery';
import Slideshow from '@/components/teacher-gallery/Slideshow';
import { mapState } from 'vuex';

export default {
  name: 'TeacherGallery',
  components: { Gallery, AppHeader, Slideshow },
  computed: {
    ...mapState('teacher', {
      showingSlideshow: state => state.showingSlideshow,
    }),
  },
};
</script>
